module.exports = __webpack_public_path__ + "fonts/OpenSans-Regular.38ca9e23.eot";